import { render, staticRenderFns } from "./ValidDisclaimer.vue?vue&type=template&id=21c78ef0&scoped=true&"
var script = {}
import style0 from "./ValidDisclaimer.vue?vue&type=style&index=0&id=21c78ef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c78ef0",
  null
  
)

export default component.exports